<template>
  <div class="template">
    <LegiWorkZoomParams />
    <LoaderFullPage v-if="store.loading" />
    <LegiWorkZoomDatas v-else />
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";

import LegiWorkZoomParams from "@follaw-fr/components/legi-work/organisms/LegiWorkZoomParams.vue";
import LegiWorkZoomDatas from "@follaw-fr/components/legi-work/organisms/LegiWorkZoomDatas.vue";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import { useLegiWorkStore } from "@follaw-fr/stores/legi-work";

const store = useLegiWorkStore();
const route = useRoute();

if (
  store.legiWorkZoom?.ref !== route.params.ref ||
  store.prevZoomUrlQuery !== JSON.stringify(route.query)
) {
  store.fetchOneLegiWork(route.params.ref);
}
</script>
